<div class="card panel-flat-color primary-panel document-processing-quick-search-panel">
    <div class="panel-flat-header document-processing-quick-search-header">
        <div class="header-icon"><i class="fa fa-search"></i></div>
        <h3>Search</h3>
        <div class="float-end header-button-container">
            <button class="ace-btn btn-text has-icon btn-primary" (click)="showCriteria = !showCriteria">
                <i class="fa fa-list"></i>
            </button>
        </div>
    </div>
    <div class="panel-flat-body p-0" style="overflow: initial;">
        @if (showCriteria) {
            <div class="card panel-flat-color secondary-panel small-panel document-processing-quick-search-criteria">
                <div class="panel-flat-header">
                    <div class="header-icon"><i class="fa fa-pencil"></i></div>
                    <h3>Criteria</h3>
                    <div class="float-end header-button-container">
                        <button class="ace-btn btn-text has-icon btn-secondary" (click)="saveCriteria()">
                            @if (savingCriteria) {
                                <i class="fa fa-spinner"></i>
                            } @else {
                                <i class="fa fa-save"></i>
                            }
                        </button>
                        <button class="ace-btn btn-text has-icon btn-primary" (click)="refreshCriteria()">
                            <i class="fa fa-refresh"></i>
                        </button>
                    </div>
                </div>
                <div class="card-body">
                    <quick-search-criteria [(criteria)]="criteria"
                                           [isDocumentProcessing]="true"
                                           [resultTypes]="resultTypes"
                                           [currentDocument]="currentDocument"
                                           (search)="search()">
                    </quick-search-criteria>
                </div>
            </div>
        }
        @if (criteria.executeSearch) {
            <div class="card panel-flat-color secondary-panel small-panel document-processing-quick-search-results">
                <div class="panel-flat-header mb-0">
                    <div class="header-icon">
                        <i class="fa fa-list"></i>
                    </div>
                    <h3>Results</h3>
                </div>
                <div class="card-body p-0">
                    <document-processing-search-result [criteria]="criteria"
                                                       [resultTypes]="resultTypes"
                                                       [showCriteria]="showCriteria"
                                                       (resultSelected)="searchResultSelected.emit($event)">
                    </document-processing-search-result>
                </div>
            </div>
        }
    </div>
</div>

